const my_profile = {
  viewMyClubSeacretProfile: "Bekijk mijn ClubSeacret-profiel", // translated
  unverifiedEmail: "Niet-geverifieerde e-mail", // translated
  verifiedEmail: "Geverifieerde e-mail", // translated
  viewMoreDetails: "Bekijk meer details", // translated
  createdFrom: "Gemaakt vanaf", // translated
  createdTo: "Gemaakt tot", // translated
  selectStatus: "Selecteer status...", // translated
  searchByTitle: "Zoeken op titel...", // translated
  pushNotifications: "Push-meldingen", // translated 
  pushNotificationsDescription: "Browsermeldingen ontvangen voor belangrijke updates en gebeurtenissen", // translated 
  pushNotificationsNotSupported: "Pushmeldingen worden niet ondersteund in deze browser", // translated 
  pushNotificationsDeniedMessage: "Meldingsmachtiging is verleend. Schakel meldingen in uw browserinstellingen in om push-meldingen te ontvangen.", // translated 
  pushNotificationsEnabled: "Pushmeldingen succesvol geaccepteerd", // translated 
  pushNotificationsDisabled: "Pushmeldingen succesvol uitgeschakeld", // translated 
  userInformationMissing: "Gebruikersinformatie ontbreekt", // translated 
  failedToUpdatePushNotifications: "Kan push-meldingsinstellingen niet verwijderen", // translated 
  notificationPermissionDenied: "Meldingsmachtiging is verleend. Schakel dit in uw browserinstellingen in.", // translated 
  notificationPermissionRequired: "Meldingsmachtiging is vereist om push-meldingen te schakelen", // translated 
  notSupported: "Niet ondersteund", // translated 
  permissionDenied: "Machtiging", // translated 
  permissionNotRequested: "Machtiging niet", // translated 
  enabled: "Ingeschakeld", // translated 
  disabled: "Uitgeschakeld", // translated 
};


export default my_profile;
